import React, { useMemo, useState } from 'react';
import ActionTypes from '@utils/deviceActions';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import { useTranslation } from 'react-i18next';
import { IDevice } from '@pages/Assets/Inventory/types';
import rolesConstants from '@utils/rolesConstants';
import SelectCustomers from '@components/SelectCustomers';

interface SyncApnPayloadProps {
  action: ActionTypes.SYNC_APN;
  processData: IDevice['customerId'];
  devices: {
    msisdn: string;
  }[];
}

interface SyncApnProps {
  devices: IDevice[];
}

const useSyncApn = ({ devices }: SyncApnProps): DeviceActionProps => {
  const { t } = useTranslation(['device-actions', 'device-actions-modal']);

  const [selectedCustomerId, setSelectedCustomerId] =
    useState<IDevice['customerId']>();

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('device-actions-modal:steps.client.name'),
        name: 'actionKey',
        showWhenUpload: true,
        content: <SelectCustomers onChange={setSelectedCustomerId} />,
      },
    ],
    [t],
  );

  const payloadToSend = useMemo(
    (): SyncApnPayloadProps => ({
      action: ActionTypes.SYNC_APN,
      processData: selectedCustomerId as IDevice['customerId'],
      devices,
    }),
    [devices, selectedCustomerId],
  );

  return {
    steps,
    payloadToSend,
    title: t(`labels.common.${rolesConstants.SYNC_APN}`),
    confirmDisabled: !selectedCustomerId,
  };
};

export default useSyncApn;
